import { render, staticRenderFns } from "./UsersSearches.vue?vue&type=template&id=4a020685&scoped=true"
import script from "./UsersSearches.vue?vue&type=script&lang=js"
export * from "./UsersSearches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a020685",
  null
  
)

export default component.exports